import { Status, type AsyncState } from '@essent/common';
import { createReducer, on } from '@ngrx/store';
import type { GetAddressCheckResponse } from '@integration/api-client/util';

import { UtilApiActions } from '../api/util.ngrx-wrapper';

export const fehAddressCheckKey = 'feh-address-check';

export type FehAddressCheckState = AsyncState<
  Partial<GetAddressCheckResponse['address']> & {
    postCode?: string;
    houseNumber?: string;
    houseNumberAddition?: string;
  }
>;
export const initialHomebatteryAddressCheckState: FehAddressCheckState = {
  status: Status.IDLE,
};

export const fehAddressCheckReducer = createReducer<FehAddressCheckState>(
  initialHomebatteryAddressCheckState,
  on(UtilApiActions.getAddressCheck.successAction, (state, params) => ({
    status: Status.SUCCESS,
    data: {
      ...state.data,
      ...params.payload.address,
    },
  })),
  on(UtilApiActions.getAddressCheck.requestAction, (state, params) => ({
    status: Status.PENDING,
    data: {
      ...params.payload,
    },
  })),
  on(UtilApiActions.getAddressCheck.errorAction, (_, params) => ({
    status: Status.ERROR,
    error: params.payload,
  }))
);
